<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">Dedicated to CT, Brad, Andrea, Sage, Grace, Dylan, Lilly Kate, Savannah, and all the friends who created this journey.</p><br/>
<p style="text-align: center;">These poems are my story, pieces of me ripped out and put on paper to be my semi-real-life biography.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4e735ae4